

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Modal, Tabs } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import can from '../../../../components/ability';

const iconStyle = {
    fontSize: 28,
}


function GoodsShow(props) {
    const { data, choose, onClick } = props;

    const fileName = data?.mainImages[0];
    const url = 'https://img.yxdj.tech/'+fileName+'?x-oss-process=image/resize,w_200';
    return (
        <div className={`dialog-info-item ${choose?'choose':''}`} onClick={() => onClick(data)}>
            <div className='item-iamge' style={{backgroundImage: `url(${url})`}} />
            <div className='item-title'>{data.title}</div>
            {choose?<CheckOutlined className='chose-icon' />: null}
        </div>
    )
}

export default (props) => {
    
    const { value, onChange, onClose, multi = true, visible, proxyList = [], myList = [] } = props;
    const [chooseList, setChooseList] = useState([]);
    useEffect(() => {
        let list = [];
        if (!value || value.length <= 0) {
            setChooseList([]);
            return;
        }
        if (Array.isArray(value)) {
            if (multi) {
                list = value;
            } else {
                list = [value[0]];
            }
        } else {
            list = [value];
        }
        setChooseList(list);
        return;
    }, [value, visible]);

    function onClickOne(data) {
        const id = data.goodsId;
        if (!multi) {
            setChooseList([id])
            return;
        }
        const index = chooseList.indexOf(id);
        let list  = []
        if (index >= 0) {
            chooseList.splice(index, 1)
        } else {
            chooseList.push(id);
        }
        list = [...chooseList];
        setChooseList(list);
    }

    function handleOk() {
        onChange(chooseList)
    }

    const shopTabs = [
        {
            key: "1",
            label: "我的商品",
            children: (
                <div className='dialog-show-item-content'>
                {
                    myList.map(i => <GoodsShow key={i.goodsId} data={i} choose={chooseList.indexOf(i.goodsId) >= 0} onClick={onClickOne} />)
                }
                </div>
            )
        },
        {
            key: "2",
            label: "我代理的商品",
            children: (
                <div className='dialog-show-item-content'>
                    {
                        proxyList.map(i => <GoodsShow key={i.goodsId} data={i} choose={chooseList.indexOf(i.goodsId) >= 0} onClick={onClickOne} />)
                    }
                </div>
            )
        }
    ];
    
    return (
        <div>
            <Modal
                title="选择商品"
                open={visible}
                onOk={handleOk}
                onCancel={onClose}
            >
              <Tabs defaultActiveKey="1" items={shopTabs} tabBarExtraContent={''} />
            </Modal>
        </div>
    );
};